import { observer } from 'mobx-react-lite';
import styles from './NavBar.module.css';
import { Button, Icon } from 'semantic-ui-react';

const Footer = () => {
    const onWhatsupClick = () => {
        let path = `https://wa.me/994512515100`;
        window.location.href = path;
    }

    return (
        <div className={styles.footer}>
            <nav>
                AZSERVICE 951.AZ MMC
                <section id="contact"><h3>Контакты:</h3></section>
                <p>&nbsp;</p>
                <Button onClick={onWhatsupClick} type='button' color='green' icon labelPosition='left' size='small'>
                    <Icon name='whatsapp' />
                    WhatsApp
                </Button>

                <p>e-mail: <a href="mailto:951@951.az">951@951.az</a></p>
            </nav>
        </div>
    );
};

export default observer(Footer)